import './NextSteps.scss';

export interface NextStepsProps {
  children: string;
}

const NextSteps: React.FC<NextStepsProps> = ({children}) => {
  return (
    <div className="container">
      <div className="container__title">Próximos passos</div>
      <div
        className="container__children"
        dangerouslySetInnerHTML={{
          __html: children,
        }}
      />
    </div>
  );
};

export default NextSteps;
